import routes from 'agentRoutes';
import httpClient from 'agentHTTPClient';
import { stopAsyncValidation, startAsyncValidation } from 'redux-form';
import React from 'react';
import { I18nText } from '@welldev-group/react-comp-lib';

const asyncTravelerEmailValidate = (formValue, customerInformationVisible, formName, dispatch) => {
  if (!formValue) return null;

  dispatch(startAsyncValidation(formName));

  const emailErrors = formValue.travelers.map((traveler, index) => {
    if (index === 0 && !customerInformationVisible) return null;

    const {
      email: { value: email },
      contactInformationCopied,
    } = traveler;
    const travelerId = (traveler.id && traveler.id.value) || null;
    const isEmailCheckNeeded =
      index === 0 || travelerId != null || contactInformationCopied.value === false;

    if (email && isEmailCheckNeeded) {
      return httpClient
        .get(routes.validations.travelerEmail({ email, traveler_id: travelerId }))
        .then(() => ({ email: null }))
        .catch(({ response }) => {
          if (response.status === 422) {
            return { email: response.data.error };
          }

          return {
            email: <I18nText id="ibe.async_validations.network_error" />,
          };
        });
    }
    return null;
  });
  return Promise.all(emailErrors)
    .then(values => {
      const errors = { travelers: values };
      return errors;
    })
    .then(allEmailErrors => dispatch(stopAsyncValidation(formName, allEmailErrors)));
};

export default asyncTravelerEmailValidate;
